module.exports = __webpack_public_path__ + "assets/img/img_no_search@2x.b0b36280.png";